/**
 * KAN-303: голосовой пакет — типы витрины кабинета.
 */

/**
 * Состояние пакета. Приходит с бэкенда посчитанным: считать его на клиенте
 * значило бы иметь два места с порогами, которые однажды разойдутся.
 */
export type VoiceBalanceState =
  /** Израсходовано меньше 80 % пакета. */
  | 'ok'
  /** 80–100 %: пора платить, но всё работает. */
  | 'low'
  /** Пакет выбран, идёт грейс-запас: обзвон ещё не встал. */
  | 'grace'
  /** Грейс исчерпан: новые исходящие не начинаются. */
  | 'stopped';

export interface VoiceBalance {
  state: VoiceBalanceState;
  /** Входят ли звонки в тариф — про СОСТАВ, а не про остаток. */
  includes_voice: boolean;
  can_place_outbound: boolean;
  included_minutes: number;
  used_minutes: number;
  /** Отрицательное значение — работа в долг. Показывать со знаком. */
  remaining_minutes: number;
  grace_minutes: number;
  period_end: string | null;
  plan_name: string;
  overage_rub: string | null;
}

export interface CallCharge {
  id: string;
  call_uuid: string;
  direction: 'outbound' | 'inbound';
  started_at: string;
  duration_seconds: number;
  billable_seconds: number;
  billed_minutes: number;
  not_billable_reason: string;
  /** Человеческая причина; пусто — звонок тарифицирован. */
  reason_display: string;
}

/** Подписи состояний. Единственное место, где состояние превращается в слова. */
export const VOICE_STATE_LABEL: Record<VoiceBalanceState, string> = {
  ok: 'В норме',
  low: 'На исходе',
  grace: 'Работа в долг',
  stopped: 'Остановлено',
};

/** Тариф в витрине — тем, что входит, а не полями базы. */
export interface TariffPlan {
  id: string;
  name: string;
  price_monthly_rub: string;
  voice_minutes_included: number;
  voice_overage_rub: string;
  includes_voice: boolean;
  max_estimates_per_month: number;
  max_data_sources: number;
  max_users: number;
  /** KAN-988: функции тарифа (коды lib/features.ts). */
  features?: string[];
}

